<div class="container">
  <div class="user-page">
    <div class="row">
      <div class="col-md-1 d-block d-sm-block d-md-none mobile-icon">
        <div class="btn-show">
          <button (click)="openAddDialog({})" mat-icon-button color="primary">
            <i class="material-icons">
              add_circle
            </i>
          </button>
        </div>
      </div>
      <div class="col-md-4">
        <form action="" class="form-fields show-search">
          <div class="form-group">
            <mat-form-field>
              <input matInput id="filter-text-box" placeholder="Search" (keyup)="onFilterTextBoxChanged($event)">
              <mat-icon matSuffix>search</mat-icon>
            </mat-form-field>
          </div>
        </form>
      </div>
      <div class="col-md-8 d-none d-sm-none d-md-block tablet-icon">
        <div class="btn-show">
          <button (click)="openAddDialog({})" mat-icon-button color="primary">
            <i class="material-icons">
              add_circle
            </i>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="all-show-grid">
    <ag-grid-angular class="ag-theme-material"   [suppressMenuHide]="true"
       groupHeaders suppressRowClickSelection toolPanelSuppressGroups toolPanelSuppressValues
      (cellDoubleClicked)="onCellClicked($event)" [gridOptions]="gridOptions" [columnDefs]="columnDefs"
      [rowData]="categoryList" (gridReady)="onGridReady($event)" [modules]="modules" [rowDragManaged]="true"
      [animateRows]="true" #grid></ag-grid-angular>
  </div>
</div>
<ng-template #Adddialog let-data>
  <h1 mat-dialog-title>Create Category</h1>
  <div mat-dialog-content>
    <form>
      <div class="row">
        <div class="col-md-4">
          <mat-form-field>
            <input matInput [(ngModel)]="data.categoryName" [ngModelOptions]="{standalone: true}" placeholder="Enter Category Name">
          </mat-form-field>
        </div>
        <div class="col-md-4">
          <mat-form-field>
            <input matInput [(ngModel)]="data.class" [ngModelOptions]="{standalone: true}" placeholder="Enter Class">
          </mat-form-field>
        </div>
        <div class="col-md-4">
          <mat-form-field>
            <input matInput [(ngModel)]="data.owner" [ngModelOptions]="{standalone: true}" placeholder="Enter Owner">
          </mat-form-field>
        </div>
        <div class="col-md-4">
          <mat-form-field>
            <mat-select placeholder="Select Template" [(ngModel)]="data.template" [ngModelOptions]="{standalone: true}">
              <mat-option *ngFor="let res of templateList; let i = index" [value]="res.id">
                {{res.title}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="action-btns text-right">
        <button mat-raised-button class="btn btn-primary m-left" color="primary" (click)="onSubmit(data)">Save</button>
      </div>
    </form>
  </div>
</ng-template>
